import { Navigate, Route, Routes } from 'react-router-dom';
import { ProtectedRoute } from './auth/ProtectedRoute';
import { Layout } from './components/Layout';
import { Login } from './pages/Login';
import { AccessPending } from './pages/AccessPending';
import { Dashboard } from './pages/Dashboard';
import { Difot } from './pages/Difot';
import { Tv } from './pages/Tv';
import { CustomerFeedback } from './pages/CustomerFeedback';
import { AdminUsers } from './pages/AdminUsers';
import { NotFound } from './pages/NotFound';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/access-pending" element={<AccessPending />} />

      {/* TV / wall-display mode — gated by login but rendered chrome-less
          (outside the Layout), so it fills the screen with no nav. */}
      <Route
        path="/tv"
        element={
          <ProtectedRoute>
            <Tv />
          </ProtectedRoute>
        }
      />

      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<Navigate to="/difot" replace />} />
        <Route path="/difot" element={<Difot />} />
        <Route path="/feedback" element={<CustomerFeedback />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route
          path="/admin/users"
          element={
            <ProtectedRoute allowRoles={['admin']}>
              <AdminUsers />
            </ProtectedRoute>
          }
        />
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
